import { ReportComponentType } from '@/types';

export interface TileConstraints {
    minW?: number;
    maxW?: number;
    minH?: number;
    maxH?: number;
    defaultW?: number;
    defaultH?: number;
}

const chart = (overrides?: Partial<TileConstraints>): TileConstraints => ({
    minW: 3,
    maxW: 6,
    minH: 16,
    maxH: 24,
    defaultW: 3,
    defaultH: 16,
    ...overrides,
});

const embed = (overrides?: Partial<TileConstraints>): TileConstraints => ({
    minW: 2,
    maxW: 6,
    minH: 16,
    maxH: 24,
    defaultW: 6,
    defaultH: 16,
    ...overrides,
});

export const componentTileConstraints: Record<ReportComponentType, TileConstraints> = {
    [ReportComponentType.TITLE]: {
        minW: 6,
        maxW: 6,
        minH: 4,
        maxH: 4,
        defaultW: 6,
        defaultH: 4,
    },
    [ReportComponentType.DESCRIPTION]: {
        minW: 3,
        maxW: 6,
        minH: 9,
        maxH: 9,
        defaultW: 6,
        defaultH: 9,
    },
    [ReportComponentType.DIVIDER]: {
        minW: 3,
        maxW: 6,
        minH: 2,
        maxH: 2,
        defaultW: 6,
        defaultH: 2,
    },
    [ReportComponentType.IMAGE]: {
        minW: 2,
        maxW: 6,
        minH: 4,
        maxH: 16,
        defaultW: 3,
        defaultH: 6,
    },
    [ReportComponentType.VIDEO]: {
        minW: 3,
        maxW: 6,
        minH: 6,
        maxH: 18,
        defaultW: 6,
        defaultH: 10,
    },
    [ReportComponentType.AUDIO]: {
        minW: 3,
        maxW: 6,
        minH: 3,
        maxH: 6,
        defaultW: 4,
        defaultH: 3,
    },
    [ReportComponentType.STATISTIC]: {
        minW: 1,
        maxW: 6,
        minH: 4,
        maxH: 16,
        defaultW: 2,
        defaultH: 4,
    },
    [ReportComponentType.MULTIPLE_STATISTICS]: {
        minW: 3,
        maxW: 6,
        minH: 4,
        maxH: 12,
        defaultW: 3,
        defaultH: 12,
    },
    [ReportComponentType.TABLE]: {
        minW: 3,
        maxW: 6,
        minH: 16,
        maxH: 24,
        defaultW: 6,
        defaultH: 16,
    },
    [ReportComponentType.MAP]: {
        minW: 2,
        maxW: 6,
        minH: 16,
        maxH: 24,
        defaultW: 6,
        defaultH: 16,
    },
    [ReportComponentType.GLOBE]: {
        minW: 3,
        maxW: 6,
        minH: 16,
        maxH: 24,
        defaultW: 6,
        defaultH: 16,
    },
    [ReportComponentType.COUNTERCYCLICAL_VANTAGE]: {
        minW: 3,
        maxW: 6,
        minH: 12,
        maxH: 18,
        defaultW: 6,
        defaultH: 12,
    },
    [ReportComponentType.FUNNEL_CHART]: chart(),
    [ReportComponentType.SANKEY_CHART]: chart(),
    [ReportComponentType.HEAT_MAP]: chart(),
    [ReportComponentType.SCATTER_PLOT]: chart(),
    [ReportComponentType.BAR_CHART]: chart(),
    [ReportComponentType.GAUGE_CHART]: chart(),
    [ReportComponentType.DONUT_CHART]: chart(),
    [ReportComponentType.PIE_CHART]: chart(),
    [ReportComponentType.AREA_CHART]: chart(),
    [ReportComponentType.LINE_CHART]: chart(),
    [ReportComponentType.RADAR_CHART]: chart(),
    [ReportComponentType.RADIAL_CHART]: chart(),
    [ReportComponentType.CHORD_CHART]: chart(),
    [ReportComponentType.EMBED]: embed(),
    [ReportComponentType.YOUTUBE]: embed(),
    [ReportComponentType.LOOM]: embed(),
    [ReportComponentType.VIMEO]: embed(),
    [ReportComponentType.GOOGLE_CALENDAR]: embed(),
    [ReportComponentType.MICROSOFT_OUTLOOK_CALENDAR]: embed(),
    [ReportComponentType.GOOGLE_DRIVE]: embed(),
    [ReportComponentType.GOOGLE_DOCS]: embed(),
    [ReportComponentType.GOOGLE_SHEETS]: embed(),
    [ReportComponentType.MICROSOFT_ONEDRIVE]: embed(),
    [ReportComponentType.DROPBOX]: embed(),
    [ReportComponentType.BOX]: embed(),
    [ReportComponentType.NOTION]: embed(),
    [ReportComponentType.GITHUB]: embed(),
    [ReportComponentType.HEX]: embed(),
    [ReportComponentType.CONFLUENCE]: embed(),
    [ReportComponentType.MIRO]: embed(),
    [ReportComponentType.LUCID]: embed(),
    [ReportComponentType.GRAPHY]: embed(),
    [ReportComponentType.MICROSOFT_POWER_BI]: embed(),
    [ReportComponentType.LOOKER]: embed(),
    [ReportComponentType.TABLEAU]: embed(),
    [ReportComponentType.ZOHO_ANALYTICS]: embed(),
};

export const tileVariables = {
    MAX_TILE_H: 24,
    MAX_TILE_W: 6,
    MIN_TILE_H: 4,
    MIN_TILE_W: 2,
};
